export default function BasketToCheckout(
    $q,
    $rootScope,
    Bookings,
    BookingPeriods,
    Basket,
    Users,
    paymentService,
    Log,
    ENV,
    Roles
) {
    var fn = this;

    fn.goToCheckout = (
        activity,
        basketBookings // legacy
    ) => {
        if (!basketBookings.length) {
            return rejector("no-basket-bookings");
        }

        return Users.getAuthenticatedUser().then(
            (user) => {
                /*
                 * Yay... User is Authorized
                 */

                // TO DO ::: MEDIUM ::: coherentBookings
                // Runs code that unite period coherent bookings (sammensatte bookings)
                // const coherentBookings = CoherentBookings.uniteBookings();
                // console.log(coherentBookings);

                /**
                 *  What now :-)
                 *
                 * if the user previously initiated created a booking, then lets check if we can continue to checkout using that.
                 *
                 *  Conditions:
                 * - requires booking ID in basket (localstorage)
                 * - If found booking ID cannot be allreadyPayed
                 * - all bps must have a status of "New"
                 * - location and activity must be the same
                 *
                 */

                /**
                 *
                 * TEST SCENRAIOS
                 */

                // TEST 1 - no booking ID
                // Basket.deleteBookingId();

                // rejections
                // Test  - force first booking period to be unavailable
                const forceFirstBookingToBeOutdated = (basketBookings) => {
                    const start = "2020-10-14T14:30:00";
                    const end = "2020-10-14T15:30:00";
                    basketBookings[0].FromDate = start;
                    basketBookings[0].ToDate = end;
                    basketBookings[0].Date = "2020-10-14";

                    basketBookings[0].BookingStart =
                        basketBookings[0].Periods[0].BookingStart = start;
                    basketBookings[0].BookingEnd =
                        basketBookings[0].Periods[0].BookingEnd = end;

                    console.warn("TEST - Forcing 1 booking to be outdated");

                    return basketBookings;
                };

                /** test activator */
                // basketBookings = forceFirstBookingToBeOutdated(basketBookings);

                // Test  - Periods is in past sense
                // Test  - Some basket periods was not available anymore

                // Test last - API errors -
                // resolvers
                // Test  - All booking periods are available...

                // Create new booking ID or continue existing ??
                const bookingId = Basket.getBookingId();

                if (!bookingId) {
                    log.info("NO BOOKING ID - Create new booking");

                    // any unavailable periods ?
                    // YES: await user to remove periods
                    // NO : create new booking

                    return createNewBookingFlow(
                        user,
                        activity,
                        basketBookings
                    ).then(
                        (res) => {
                            // USE EXISTING
                            return resolver("READY FOR CHECKOUT");
                        },
                        (err) => {
                            // FORCE USER TO DELECT UNAVAILABLE PERIODS
                            return rejector(err.reason, err.obj);
                        }
                    );
                }

                return paymentService.getPaymentUrl(bookingId).then(
                    (res) => {
                        if (res.AlreadyPayed) {
                            log.info(
                                "BOOKING AlreadyPayed - Create new booking"
                            );

                            // any unavailable periods ?
                            // YES: await user to remove periods
                            // NO : create new booking
                            return createNewBookingFlow(
                                user,
                                activity,
                                basketBookings
                            ).then(
                                (res) => {
                                    // USE EXISTING
                                    return resolver("READY FOR CHECKOUT");
                                },
                                (err) => {
                                    // FORCE USER TO DESELECT UNAVAILABLE PERIODS
                                    return rejector(err.reason, err.obj);
                                }
                            );
                        } else {
                            return Bookings.get(bookingId).then(
                                (res) => {
                                    const apiBooking = res;

                                    return existingBookingFlow(
                                        user,
                                        activity,
                                        basketBookings,
                                        apiBooking
                                    ).then(
                                        (res) => {
                                            // USE EXISTING
                                            return resolver(
                                                "CHECKOUT existing"
                                            );
                                        },
                                        (err) => {
                                            // AWAIT USER TO REMOVE UNAVAILABLE PERIODS
                                            return rejector(
                                                err.reason,
                                                err.obj
                                            );
                                        }
                                    );
                                },
                                (err) => {
                                    // any unavailable periods ?
                                    // YES: await user to remove periods
                                    // NO : create new booking

                                    return createNewBookingFlow(
                                        user,
                                        activity,
                                        basketBookings
                                    ).then(
                                        (res) => {
                                            // USE EXISTING
                                            return resolver(
                                                "READY FOR CHECKOUT"
                                            );
                                        },
                                        (err) => {
                                            // AWAIT USER TO REMOVE UNAVAILABLE PERIODS
                                            return rejector(
                                                err.reason,
                                                err.obj
                                            );
                                        }
                                    );
                                }
                            );
                        }
                    },
                    (err) => {
                        return rejector(
                            "Legacy API error - getPaymentUrl",
                            err.obj
                        );
                    }
                );
            },
            (err) => {
                /*
                 * Unauthorized
                 */
                return rejector("user-not-authorized", err);
            }
        );
    };

    const crossCheckUnavailablePeriodsWithApiBooking = (
        unavailablePeriods,
        apiBooking
    ) => {
        /** Legacy note -> one booking has one period */

        const updatedUnavailablePeriods = unavailablePeriods.filter(
            (basketBooking) => {
                // ?? basketBooking = Basket.CheckPeriodDateIsExpired(basketBooking.BookingEnd);

                let stillUnavailable = true;

                apiBooking.bookingPeriods.forEach((apiPeriod) => {
                    basketBooking.BookingStart == apiPeriod.start &&
                    basketBooking.BookingEnd == apiPeriod.end
                        ? (stillUnavailable = false)
                        : null;
                });

                stillUnavailable == false
                    ? log.info(
                          "Period match found on existing booking : " +
                              basketBooking.LaneName +
                              "Start kl." +
                              basketBooking.BookingStart
                      )
                    : null;

                return stillUnavailable;
            }
        );

        return updatedUnavailablePeriods;
    };

    const existingBookingFlow = (
        user,
        activity,
        basketBookings,
        apiBooking
    ) => {
        log.info("Existing booking flow");
        /*
         * continue existing ApiBooking ?
         * Conditions:
         *
         *    any unavailable periods
         *       ? does it exist in apiBooking (user owns this)
         *          ? continue existing apiBooking ( the user owns it )
         *          : await user to remove periods
         *       : await user to remove periods
         *    : continue existing apiBooking;
         */
        /*
         updateBpsAvailability 
            ? resolver =  useExistingBooking() = all available 
            : rejector = conditionalExistingBooking() = unavailable periods = does unavailable periods exist in apiBooking)
                    ? resolver = useExistingBooking() = all should be available now
                    : rejector : await user to remove periods
        */

        return updateBpsAvailability(basketBookings).then(
            (res) => {
                const updatedBasketBookings = res.obj;

                log.info("updated (API) Basket Bookings with availability");

                let unavailablePeriods = getUnavailablePeriods(
                    updatedBasketBookings
                );

                /**
                 *
                 * Cross check ApiBooking and unavailablePeriods.. (bookingStart, BookingEnd)
                 * To see if any of the unavailable is actually the users own reservation
                 */

                if (
                    unavailablePeriods.length &&
                    apiBooking.bookingPeriods.length
                ) {
                    log.info("crossCheckUnavailablePeriodsWithApiBooking");

                    unavailablePeriods =
                        crossCheckUnavailablePeriodsWithApiBooking(
                            unavailablePeriods,
                            apiBooking
                        );
                }

                /**
                 * any unavailable periods ?
                 * Cannot proceed to checkout when some of the periods has become unavailable
                 */

                if (unavailablePeriods.length !== 0) {
                    log.info("still has unavailable Periods");

                    return rejector("await-user-to-remove-periods", {
                        unavailablePeriods: unavailablePeriods,
                        updatedBasketBookings: updatedBasketBookings,
                    });
                }

                return useExistingBooking(
                    user,
                    activity,
                    updatedBasketBookings,
                    apiBooking
                ).then(
                    () => {
                        return resolver(
                            "booking periods created ApiV3 format",
                            null
                        );
                    },
                    (err) => {
                        return rejector(
                            "could-not-create-booking-periods",
                            err
                        );
                    }
                );
            },
            (err) => {
                return conditionalExistingBooking().then(
                    (res) => {
                        return useExistingBooking().then(
                            (res) => {
                                /**
                                 * resolver
                                 */
                                log.string("Addded existing periods");
                                return resolver(
                                    "Added periods to booking",
                                    err
                                );
                            },
                            (err) => {
                                log.string("API could not add booking periods");

                                return rejector(
                                    "API could not add booking periods",
                                    err
                                );
                            }
                        );
                    },
                    (err) => {
                        // console.warn(err);
                        return rejector(err.reason, err);
                    }
                );
            }
        );
    };

    const createNewBookingFlow = (user, activity, basketBookings) => {
        log.info("create New Booking Flow");
        // any unavailable periods ?
        // YES: await user to remove periods
        // NO : create new booking
        /*
         updateBpsAvailability 
            ? resolver = createNewBookingId() = all available
            : rejector : await user to remove periods 
        */
        return updateBpsAvailability(basketBookings).then(
            (res) => {
                const updatedBasketBookings = res.obj;

                const unavailablePeriods = getUnavailablePeriods(
                    updatedBasketBookings
                );

                /*
                 * any unavailable periods ?
                 * Cannot proceed to checkout when some of the periods has become unavailable
                 */

                if (unavailablePeriods.length == 0) {
                    return createNewBookingId(user).then(
                        (res) => {
                            const newBookingId = res.obj; // number
                            log.info("New Booking Id created");

                            return createBookingPeriods(
                                user,
                                activity,
                                updatedBasketBookings, // legacy
                                newBookingId
                            ).then(
                                (res) => {
                                    /**
                                     * SUCCESS - LAST ACTION IN createNewBookingFlow
                                     */
                                    return resolver(
                                        "Booking with periods created",
                                        null
                                    );
                                },
                                (err) => {
                                    return rejector(
                                        "API - booking periods could not be created",
                                        err
                                    );
                                }
                            );
                        },
                        (err) => {
                            return rejector(err.reason, err.obj); // passthrough
                        }
                    );
                } else {
                    return rejector("await-user-to-remove-periods", {
                        unavailablePeriods: unavailablePeriods,
                        updatedBasketBookings: updatedBasketBookings,
                    });
                }
            },
            (err) => {
                // API error when checking availability
                return rejector(err.reason, err);
            }
        );
    };

    const updateBpsAvailability = (basketBookings) => {
        return checkPeriods(basketBookings).then(
            (res) => {
                const updatedBasketBookings = res; // legacy bookings

                return resolver(
                    "bookings availability updated",
                    updatedBasketBookings
                );
            },
            (err) => {
                console.warn(err);
                return rejector("API error when checking availability", err);
            }
        );

        // TO DO ::: MEDIUM ::: Combined bookings ???
        // IMPORTANT !! bookingService.combinedBookngs must be send to server!!
    };

    const useExistingBooking = (
        user,
        activity,
        availableBookings,
        apiBooking
    ) => {
        /**
         * To allow the user to continue using an ongoing booking (by BookingId from Basket (localStorage)
         * Mayby the user changed som of the periods, so we must refill the booking DB row at checkout..
         * To do that we must:
         * 1 DELETE booking/id/bookingPeriods
         * 2 POST booking/id/bookingPeriods (from basket)
         */
        return deleteBookingPeriods(apiBooking).then(
            () => {
                return createBookingPeriods(
                    user,
                    activity,
                    availableBookings, // legacy
                    apiBooking.id
                );
            },
            (err) => {
                return rejector("API - could not delete booking periods", err);
            }
        );
    };

    const conditionalExistingBooking = (apiBooking) => {
        if (!apiBooking) {
            return rejector("No apiBooking found - create new", apiBooking);
        }

        /**
         * It creates set of bp statuses
         * Set() only allows unique values
         */
        const statuses = new Set(
            apiBooking.bookingPeriods.map((bp) => bp.status)
        );

        /**
         * Conditional BL to use existing booking
         * - All periods must have a status of "New"
         */

        return statuses.size == 0
            ? resolver("No booking periods - continue existing", apiBooking)
            : statuses.size == 1
            ? statuses.values().next().value === "New"
                ? resolver("continue existing basket booking", apiBooking)
                : rejector("bp status is not 'New' - cannot use existing", null)
            : rejector("mixed bp statuses - cannot use existing", null);
    };

    const createBookingPeriods = (
        user,
        activity,
        availableBookings, // legacy
        bookingId
    ) => {
        return Roles.get(user.primaryRole).then((role) => {
            const promises = availableBookings.map((period) => {
                return Bookings.createBookingPeriodLegacy(
                    period,
                    bookingId,
                    activity,
                    user,
                    role.defaultBookingTypeId
                );
            });

            return $q.all(promises);
        });
    };

    const deleteBookingPeriods = (apiBooking) => {
        const promises = apiBooking.bookingPeriods.length
            ? apiBooking.bookingPeriods.map((bp) => {
                  return Bookings.deleteBookingPeriod(bp);
              })
            : resolver("no bps in apiBooking", apiBooking);

        return $q.all(promises);
    };

    const createNewBookingId = (user) => {
        return Bookings.createBookingId(user.id).then(
            (bookingId) => {
                Basket.setBookingId(bookingId);
                return resolver(
                    "New booking created ID : " + bookingId,
                    bookingId
                );
            },
            (err) => {
                return rejector("create bookingID API error");
            }
        );
    };

    const getUnavailablePeriods = (updatedBasketBookings) => {
        /**
         * Extract unavailable periods
         */
        /** Assumes that each booking only has one period  */
        return updatedBasketBookings.filter((booking) => {
            return !booking.Periods[0].Available;
        });
    };

    /**
     * Request the Api for availability
     *
     * @return {promise}
     */
    const checkPeriods = (basketBookings) => {
        const promises = basketBookings.map((booking) => {
            return checkPeriodAvailability(booking);
        });

        return $q.all(promises).then(
            (res) => {
                /**
                 * Since wee need to update the booking (each) period (each)..
                 * and resolve with promises the array gets nested
                 * Unpack the outer useless array wrap
                 */
                return res.map((booking) => booking[0]);
            },
            (err) => {
                return rejector(err.reason, err.obj); // passthrough
            }
        );
    };

    /**
     * Get Available Repeatable as a Promise
     * @param  {obj} weekday [description]
     * @param  {obj} booking [description]
     * @return {promise} [description]
     */
    const checkPeriodAvailability = (booking) => {
        // Assume we always have just 1 period in a booking

        console.log(booking);

        const expiredBooking = Basket.CheckPeriodDateIsExpired(
            booking.BookingEnd
        );

        const promises = booking.Periods.map((period, index) => {
            // https://momentjs.com/docs/#/displaying/as-iso-string/
            return BookingPeriods.checkAvailability(
                period.BookingStart, // legacy
                period.BookingEnd, // legacy
                period.LaneID, // legacy
                booking.id,
                period // used to DummyApiPeriod
            ).then(
                (res) => {
                    // http://localhost:8080/search/periods/fodbold,%205-mands%20/hafnia-hallen?date=28-11-2020&start=6&end=23&hours=1

                    /** reponse ApiV3
                     * available: true || false // we only need to copy this as long as we are legacy
                     * end: "2020-11-28T12:00:00"
                     * resource: {id: 45, parentId: 20, name: "Hafnia-Kunstgræs 5-Mands - Bane 1", locationId: 34, parent: null, …}
                     * start: "2020-11-28T11:00:00"
                     * success: true
                     * message: "Check period succeeded"
                     */

                    period.Available = expiredBooking
                        ? false
                        : res.data.available; // true || false - convert availability to Legacy

                    booking.Periods[index] = period;

                    return $q.resolve(booking); // do not use resolver() here
                },
                (err) => {
                    console.warn(err);
                    // period.Available = false;
                    return rejector("API error checkAvailability", err);
                }
            );
        });

        return $q.all(promises);
    };

    /*
     ***** Utilities *****
     */
    const resolver = (reason, obj = null) => {
        log.string("resolver : " + reason, "basket-resolve");
        return $q.resolve({ reason: reason, obj: obj });
    };

    const rejector = (reason, obj = null) => {
        log.string("rejector : " + reason, "basket-rejection");
        return $q.reject({ reason: reason, obj: obj });
    };

    const log = {
        info: (string, theme = "basket-info") => {
            Log.string("basket to checkout : info:", string, theme);
        },
        string: (string, theme = "basket-info") => {
            Log.string("basket to checkout :", string, theme);
            ENV.enableLog ? console.log(string) : null;
        },
        obj: (obj, theme = "basket-info") => {
            Log.obj("basket to checkout", obj, theme);
        },
    };

    return fn;
}
